import { createSlice } from '@reduxjs/toolkit'
import { GetNotificationsResponseType } from '../../actions/types'
import { getAllNotifications, readAllNotifications } from '../../actions/notificationsAction'

export interface INotifications {
  notifications: GetNotificationsResponseType
  error: any
  isLoading: boolean
}

const initialState: INotifications = {
  notifications: [],
  error: '',
  isLoading: false,
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllNotifications.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getAllNotifications.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.notifications = action.payload
    })
    builder.addCase(getAllNotifications.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(readAllNotifications.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(readAllNotifications.fulfilled, (state, action) => {
      state.isLoading = false
      state.notifications = action.payload
      state.error = ''
    })
    builder.addCase(readAllNotifications.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
  },
})

export const notificationsReducer = notificationsSlice.reducer
